
const Card = ({ children, title, className = '', ...props }) => {
  return (
    <div
      className={`card bg-base-100 shadow-md ${className}`}
      style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)' }}
      {...props}
    >
      <div className="card-body">
        {title && <h2 className="card-title">{title}</h2>}
        {children}
      </div>
    </div>
  );
};

export default Card;